import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { IMedicalLeave } from '@shared/interfaces/medical-leave.interface';
import { IResponseAPI } from '@shared/interfaces/response-api.interface';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { AppState } from '@core/store/app.reducers';
import { IUser } from '@shared/interfaces/user.interface';

const URL = environment.apiBaseUrl;

@Injectable({
  providedIn: 'root',
})
export class LmRecordsService {
  private usuario: IUser = null;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select('auth').subscribe((auth) => {
      this.usuario = auth.user;
    });
  }

  getLicencesByStateAndUser(filter: string) {
    return this.http
      .get<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias?nombre=filtro_uno&valor=${encodeURIComponent(filter)}`)
      .pipe(map((response) => response.items));
  }

  getLicencesUnassigned(filterOne: string) {
    const typeLm = ['full', 'mixta', 'papel']; // TODO:  filter: LM#pendiente_contraloria#138#papel#ccaf
    const payingEntity = ['ccaf', 'directo', 'reembolso'];
    const filtroUnoSplited = filterOne.split('#');
    let filtros = [];
    if (filtroUnoSplited[3] === 'todos') {
      filtros = typeLm.map(
        (x) => `${filtroUnoSplited[0]}#${filtroUnoSplited[1]}#${filtroUnoSplited[2]}#${x}#${filtroUnoSplited[4]}`,
      );
    }
    if (filtroUnoSplited[4] === 'todos') {
      filtros = payingEntity.map(
        (x) => `${filtroUnoSplited[0]}#${filtroUnoSplited[1]}#${filtroUnoSplited[2]}#${filtroUnoSplited[3]}#${x}`,
      );
    }
    if (filtroUnoSplited[3] === 'todos' && filtroUnoSplited[4] === 'todos') {
      filtros = [];
      typeLm.map((tipoLm) => {
        payingEntity.map((entidadPagaora) => {
          filtros.push(
            `${filtroUnoSplited[0]}#${filtroUnoSplited[1]}#${filtroUnoSplited[2]}#${tipoLm}#${entidadPagaora}`,
          );
        });
      });
    }
    const licencias$ = filtros.map((query) => {
      return this.http
        .get<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias?nombre=filtro_uno&valor=${encodeURIComponent(query)}`)
        .pipe(map((response) => response.items));
    });
    return forkJoin(licencias$).pipe(map((lms) => [].concat.apply([], lms)));
  }

  getAllLicensesBySubcomission(filterOne: string) {
    const filtroUnoSplited = filterOne.split('#'); // TODO: LM#pendiente_contraloria#136,137,138#todos#todos
    const subcomisiones = filtroUnoSplited[2].split(',');
    const typeLm = ['full', 'mixta', 'papel'];
    const payingEntity = ['ccaf', 'directo', 'reembolso'];

    let filtros = [];
    if (filtroUnoSplited[3] === 'todos' && filtroUnoSplited[4] === 'todos') {
      filtros = [];
      typeLm.map((tipoLm) => {
        payingEntity.map((entidadPagaora) => {
          subcomisiones.map((subcomision) => {
            filtros.push(`${filtroUnoSplited[0]}#${filtroUnoSplited[1]}#${subcomision}#${tipoLm}#${entidadPagaora}`);
          });
        });
      });
    }

    const licencias$ = filtros.map((query) => {
      return this.http
        .get<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias?nombre=filtro_uno&valor=${encodeURIComponent(query)}`)
        .pipe(map((response) => response.items));
    });
    return forkJoin(licencias$).pipe(map((lms) => [].concat.apply([], lms)));
  }

  assignLicences(data: Array<IMedicalLeave>) {
    const responses = data.map((body) => {
      const lmSK = body.SK;
      return this.http.put<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias/${encodeURIComponent(lmSK)}`, body);
    });
    return forkJoin(responses);
  }
  getLicencesBySK(lmSK: string): Observable<IMedicalLeave[]> {
    return this.http
      .get<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias/${encodeURIComponent(lmSK)}`)
      .pipe(map((response) => response.items));
  }

  updateLicence(data: IMedicalLeave) {
    return this.http
      .put<IResponseAPI>(`${URL}/licencias-medicas/v1/licencias/${encodeURIComponent(data.SK)}`, data)
      .pipe(map((response) => response));
  }
}
